<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-2
        p.mb-0 Crear o actualizar contacto
        p.text-secondary.text-sm.mb-1 Busca un contacto mediante el correo y/o el número celular, si existe el contacto actualiza la información con los nuevos datos, en caso contrario se crea uno nuevo.
        p.text-secondary.text-sm.mb-0 Los datos de
          span.text-primary.ml-1 Nombre
          span.mr-1 ,
          span.text-primary Apellido
          span.mr-1 ,
          span.text-primary Correo
          span.mr-1 ,
          span.text-primary Teléfono celular
          span.mr-1 , son requeridos.
        result-description.mb-2(variable-name="contact_info", variable-type="object")
        fieldset(:disabled="disabled")
          b-form-group.mb-1(label="Título:", description="Valores permitidos Sra., Srta., Sr., Lda., Ldo., Dra., Dr." label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'title'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Título", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Nombre:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'first_name'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Nombre", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Apellido:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'last_name'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Apellido", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Correo:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'email'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Correo", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Teléfono celular:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'cell_phone'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Teléfono celular", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Teléfono fijo:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'phone'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Teléfono fijo", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Fecha de nacimiento:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'birthday'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Fecha de nacimiento", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Dirección:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'address'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Dirección", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="RFC:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'rfc'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="RFC", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Nombre de empresa:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'commercial_name'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Nombre de empresa", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label="Dirección comercial:", label-size="sm", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'bussines_address'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Dirección comercial", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
      create-or-update-contact-element(v-for="element in Elements", :key="element.element_id", v-if="element.type === 'contact_data'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", @destroy="destroyTemplateElement(element)")
      add-element-button.mb-3(v-if="!disabled", @click="createTemplateElement")
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import templateCommon from '../../helpers/template-common'
import Connector from './connectors/Connector.vue'
import TemplateTools from './common/Tools.vue'
import ResultDescription from './helpers/ResultDescription'
import AddElementButton from '../AddElementButton.vue'
import CreateOrUpdateContactElement from './CreateOrUpdateContactElement'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  data () {
    return {
    }
  },
  methods: {
    createTemplateElement () {
      const element = {
        type: 'contact_data',
        number: this.Elements.length + 1,
        attributes: [
          {
            name: 'contact_data_key',
            value: ''
          },
          {
            name: 'contact_data_value',
            value: ''
          }
        ]
      }
      this.createElement(this.block_id, this.template_id, element)
    },
    destroyTemplateElement(element) {
      this.destroyElement(this.block_id, this.template_id, element)
    },
    update (template_attribute, value) {
      template_attribute.value = value
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, attribute)
    },
  },
  components: {
    'template-connector': Connector,
    TemplateTools,
    ResultDescription,
    AddElementButton,
    CreateOrUpdateContactElement
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId) => {
      if (collapseId === `advance_search_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const newValue = value.target._value

      this.update(template_attribute, newValue)

      this.$message.success('Actualizado')
    }, 100, { leading: false, trailing: true })
  },
}
</script>

<style lang="scss" scoped>

</style>
